import { render, staticRenderFns } from "./PlayerContestsRewards.vue?vue&type=template&id=168ffa58&scoped=true&"
import script from "./PlayerContestsRewards.vue?vue&type=script&lang=js&"
export * from "./PlayerContestsRewards.vue?vue&type=script&lang=js&"
import style0 from "./PlayerContestsRewards.vue?vue&type=style&index=0&id=168ffa58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ffa58",
  null
  
)

export default component.exports